import { render, staticRenderFns } from "./ExamNavMenuView.vue?vue&type=template&id=4a2507b4&scoped=true&"
import script from "./ExamNavMenuView.vue?vue&type=script&lang=js&"
export * from "./ExamNavMenuView.vue?vue&type=script&lang=js&"
import style0 from "./ExamNavMenuView.vue?vue&type=style&index=0&id=4a2507b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2507b4",
  null
  
)

export default component.exports